import { createStore, applyMiddleware, combineReducers } from 'redux';
import { thunk } from 'redux-thunk';
// Global reducers
import authReducer from './global_redux/global_reducers/Login.reducer';
import clientReducer from './global_redux/global_reducers/Client.reducer';
import unitReducer from './global_redux/global_reducers/Unit.reducer';
import statesReducer from './global_redux/global_reducers/States.reducer';
import permissionReducer from './global_redux/global_reducers/Permission.reducer';
import roleReducer from "./global_redux/global_reducers/Role.reducer"
import Client_unit_wise_holidays from "./global_redux/global_reducers/Client_unit_wise_holidays.reducer"
import Holidays from "./global_redux/global_reducers/Holidays.reducer"
import currentMonthReducer from "./global_redux/global_reducers/Currentmonth.reducer"
import Contractor from "./register_redux/register_reducers/Contractor.reducer"
import createReportAndReportColumnReducer from './global_redux/global_reducers/CreateReport.reducer';
import DownloadSelectedIDsReducer from "./global_redux/global_reducers/Download.reducer"
import returnsFormsReducer from "./register_redux/register_reducers/ReturnsForms.reducer"
// Register reducers
import fetchPanIndiaReducer from "./register_redux/register_reducers/Pan_india_form.reducer"
import EmployeeReducer from "./register_redux/register_reducers/Employee.reducer"
import SalaryReducer from "./register_redux/register_reducers/Salary_register.reducers"
import ctcMasterReducer from "./register_redux/register_reducers/CtcMaster.reducer"
import generateFormReducer from "./register_redux/register_reducers/generateForm.reducer"
import leaveReducer from "./register_redux/register_reducers/Leave.reducer"
import leaveRegisterReducer from "./register_redux/register_reducers/Leave_register.reducer"
import AttendanceRegisterReducer from "./register_redux/register_reducers/AttendanceRegister.reducer"
import AttendanceRegisterOverrideReducer from "./register_redux/register_reducers/AttendanceRegisterOverride.reducer"
import MaternityBenefits from "./register_redux/register_reducers/maternityBenefits.reducer"
import FormReducer from "./register_redux/register_reducers/Form.reducer"
import SalaryAdvances from "./register_redux/register_reducers/SalaryAdvance.reducer"
import OtherInputs from "./register_redux/register_reducers/OtherInputs.reducer"
import Emp_Separation from './register_redux/register_reducers/Emp_Separation.reducer';
import LeaveOpeningBalanceReducer from './register_redux/register_reducers/Leave_opening_balance.reducer';
import getAllReportsReducer from './register_redux/register_reducers/Report.reducer';
import headerReducer from './register_redux/register_reducers/Header.reducer';
import companyDetailsReducer from './global_redux/global_reducers/CompanyDetails.reducer';
import dashboardReducer from './global_redux/global_reducers/Dashboard.reducer';

const rootReducer = combineReducers({
  auth: authReducer,
  client: clientReducer,
  unit: unitReducer,
  states: statesReducer,
  permissions: permissionReducer,
  roles: roleReducer,
  client_unit_holidays: Client_unit_wise_holidays,
  companyDetails: companyDetailsReducer,
  holidays: Holidays,
  currentmonth: currentMonthReducer,
  Contractor:Contractor,
  createReportAndReportColumnReducer:createReportAndReportColumnReducer,
  panIndiaFoms: fetchPanIndiaReducer,
  employees: EmployeeReducer,
  salaryRegister: SalaryReducer,
  ctcMaster: ctcMasterReducer,
  generateForm: generateFormReducer,
  leave: leaveReducer,
  leave_register: leaveRegisterReducer,
  AttendanceRegister: AttendanceRegisterReducer,
  AttendanceRegisterOverrideReducer: AttendanceRegisterOverrideReducer,
  MaternityBenefits: MaternityBenefits,
  SalaryAdvances: SalaryAdvances,
  FormReducer: FormReducer,
  downloadSelectedIds: DownloadSelectedIDsReducer,
  other_inputs: OtherInputs,
  emp_separation: Emp_Separation,
  leavesopeningbalance: LeaveOpeningBalanceReducer,
  reports:getAllReportsReducer,
  headers:headerReducer,
  reportdata :createReportAndReportColumnReducer,
  dashboard_record :dashboardReducer,
  returnsForms: returnsFormsReducer,
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
